import { useBooleanFlags } from '@/domains/core/flags/flags.hooks';
import { getMarket, getPlatform } from '@/domains/core/settings/utils';
import { Label } from '@/domains/core/tamagoshiTailwind/components/Label/Label';
import { useAuth } from '@/domains/customerManagement/auth/hooks/useAuth';
import { useLoyaltyProgramActivated } from '@/domains/loyalty/modules/LoyaltyProgram/hooks/useLoyaltyProgramActivated.default';
import { ENABLE_LOYALTY_PROGRAM_HVC_PRODUCT_PAGE_EARN_LABEL } from '@/domains/loyalty/modules/LoyaltyProgramHvc/constants';
import { useLoyaltyHvcUserCashbackPercentageQuery } from '@/domains/loyalty/modules/LoyaltyProgramHvc/generated/loyaltyHvcUserCashbackPercentage.generated';
import { Channel, Market, Platform } from '@/generated/graphql/types';
import { StringAbTests } from '@/productDiscovery/ProductPage/constants';

import { loyaltyCashbackPerentageLabel } from './translations';

export const CashbackPercentageLabel = () => {
  const [isLoyaltyLabelEnabled, isProductPageRevampEnabled] = useBooleanFlags([
    ENABLE_LOYALTY_PROGRAM_HVC_PRODUCT_PAGE_EARN_LABEL,
    StringAbTests.ENABLE_PRODUCT_PAGE_REVAMP,
  ]);

  const {
    hasRetrievedAuthStatus,
    isAuthenticated,
    hasRetrievedCustomerSegments,
    isGuest,
  } = useAuth();

  const { isOptOutLoyaltyProgramV2 } = useLoyaltyProgramActivated();

  const [{ data, fetching, error }] = useLoyaltyHvcUserCashbackPercentageQuery({
    requestPolicy: 'cache-and-network',
    pause:
      !hasRetrievedAuthStatus ||
      (isAuthenticated && !hasRetrievedCustomerSegments) ||
      isGuest ||
      isOptOutLoyaltyProgramV2 ||
      !isLoyaltyLabelEnabled,
    variables: {
      platform: getPlatform().toUpperCase() as Platform,
      market: getMarket().toUpperCase() as Market,
      channel: 'WEB' as Channel,
    },
  });

  const cashbackPercentage =
    data?.loyaltyHVCLevelStatus?.level.cashbackPercentage || 0;

  const shouldShowCashbackLabel = !error && !fetching && cashbackPercentage > 0;

  if (!shouldShowCashbackLabel) {
    return null;
  }
  return (
    <div
      className={isProductPageRevampEnabled ? 'self-start' : 'mr-xs self-end'}
    >
      <Label
        text={
          loyaltyCashbackPerentageLabel.format({
            cashbackPercentage,
          }) as string
        }
        variant="LoyaltyTertiary"
      />
    </div>
  );
};
